import React, { useState, useEffect } from "react"
import { Descriptions, Modal, Table, Tag } from "antd"
import dayjs from "dayjs"
import ReportPoolDataService from "src/services/ReportPoolDataService"
import { number } from "prop-types"

const ReportModal = ({ open, onCancel, initialValues }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    const fetchSim = async () => {
      try {
        const res = await ReportPoolDataService.getDetailReportPoolWallet(
          initialValues.ID
        )
        setData(res.success || [])
      } catch (err) {
        console.error("Lỗi khi load data:", err)
      }
    }

    if (open) fetchSim()
  }, [open])


  return (
    <Modal
      title="Chi tiết ví Data"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={700}
    >
      <Descriptions
        bordered
        column={2}
        size="small"
      >
        <Descriptions.Item label="Tên khách hàng">
          {data.customerName}
        </Descriptions.Item>

        <Descriptions.Item label="Tên thuê bao">
          {data.subName}
        </Descriptions.Item>

        <Descriptions.Item label="Mã thuê bao">
          {data.subCode}
        </Descriptions.Item>

        <Descriptions.Item label="Gói cước">
          {data.packageName}
        </Descriptions.Item>

        <Descriptions.Item label="Số điện thoại">
          {data.phoneActive}
        </Descriptions.Item>

        <Descriptions.Item label="Dung lượng mua">
          {data.purchasedTraffic?.toLocaleString()} MB
        </Descriptions.Item>

        <Descriptions.Item label="Dung lượng còn lại">
          {data.totalRemainingTraffic?.toLocaleString()} MB
        </Descriptions.Item>

        <Descriptions.Item label="Thời gian sử dụng" span={2}>
          {data.timeUsed}
        </Descriptions.Item>

        <Descriptions.Item label="Ngày bắt đầu">
          {dayjs(data.startDate).format("DD/MM/YYYY")}
        </Descriptions.Item>

        <Descriptions.Item label="Ngày kết thúc">
          {dayjs(data.endDate).format("DD/MM/YYYY")}
        </Descriptions.Item>

        <Descriptions.Item label="Mã thanh toán">
          {data.payCode}
        </Descriptions.Item>

        <Descriptions.Item label="Thuế">{data.tax}</Descriptions.Item>

        <Descriptions.Item label="Trạng thái">
          {data.status === 1 ? (
            <Tag color="green">Hoạt động</Tag>
          ) : (
            <Tag color="red">Không hoạt động</Tag>
          )}
        </Descriptions.Item>

        <Descriptions.Item label="Giá 1GB">
          {typeof data.price_1gb !== number ? Number(data.price_1gb).toLocaleString() : data.price_1gb.toLocaleString()}
        </Descriptions.Item>

        <Descriptions.Item label="Giảm giá">
          {typeof data.price_discount !== number ? Number(data.price_discount).toLocaleString() : data.price_discount.toLocaleString()}
        </Descriptions.Item>

        <Descriptions.Item label="Có thể chia sẻ">
          {data.canShare ? "Có" : "Không"}
        </Descriptions.Item>
      </Descriptions>
    </Modal >
  )
}

export default ReportModal
